<template>
  <v-card>
    <div v-padding="3">
      <v-form ref="form" :errors="errors" :defaultValues="defaultValues" @submit="handleSubmit"
        :readonly="isRequestCreating">
        <template scope="api">
          <v-stepper-content>
            <v-row>
              <v-col xs="6">
                <v-form-input field="lastName" label="Фамилия" :required="true" :readonly="true" v-margin.bottom="2" />
                <v-form-input field="firstName" label="Имя" :required="true" :readonly="true" v-margin.bottom="2" />
                <v-form-input field="middleName" label="Отчество" :required="false" :readonly="true"
                  v-margin.bottom="2" />
                <v-form-input field="dateBirth" label="Дата рождения" :required="true" :readonly="true"
                  caption="ДД / ММ / ГГГГ" mask="date" v-margin.bottom="2" />
                <v-form-input field="documentSeries" label="Паспорт серия" :required="true" :readonly="true"
                  v-margin.bottom="2" />
                <v-form-input field="documentNumber" label="Паспорт номер" :required="true" :readonly="true"
                  v-margin.bottom="2" />

                <v-form-input field="monitoringEndDate" :required="true" label="Дата окончания мониторинга"
                  caption="ММ/ГГГГ" mask="dateWithoutDay" :placeholder="placeholderDate" v-margin.bottom="2"
                  @input="onMonitoringDateChange" />

                <div v-if="monitoringDateError" v-margin.bottom="2" class="error-message">
                  <v-text error type="caption" style="color: #ff4444;">
                    {{ monitoringDateError }}
                  </v-text>
                </div>

                <div v-margin.bottom="2">
                  <v-text type="caption">
                    Мониторинг действует по конец выбранного месяца включительно.
                  </v-text>
                </div>

                <v-form-checkbox data=true v-margin.bottom="2" field="agreementReceived" :required=true>
                  <template slot="label" scope="label">
                    <v-text> Получено согласие субъекта на обработку его перс. данных. </v-text>
                  </template>
                </v-form-checkbox>

                <v-spinner :active="isRequestCreating">
                  <v-button type="submit" primary :disabled="api.isInvalid || isRequestCreating || !isFormValid">
                    Продлить мониторинг
                  </v-button>
                </v-spinner>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-label icon="error">
            <v-text type="subheadling"> Итого: {{ calculatedTotal }} руб </v-text>
          </v-stepper-label>

          <v-stepper-label icon="warning" :danger="true" v-if="isBackendError">
            <v-text type="caption" :danger="true"> {{ backendErrorMessage }} </v-text>
          </v-stepper-label>
        </template>
      </v-form>
    </div>
  </v-card>
</template>

<script>

export default {
  name: "renewal-monitoring",

  props: {
    onRenewal: Function,
    total: {
      type: Number,
      default: 0,
    },
    productData: {
      type: Object,
      default: () => ({
        id: 0,
        name: '',
        cost: 0,
        freeCount: 0,
        availableCount: 0,
        isIndividual: false,
        isEnable: false,
        crashingMessage: null,
        identificationRequired: false,
        availableAgreementTypes: [],
      })
    },
    renewalData: {
      type: Object,
      default: () => ({
        lastName: '',
        firstName: '',
        middleName: '',
        dateBirth: '',
        passportSeries: '',
        passportNumber: '',
        currentMonitoringEnd: null,
        monitoringId: ''
      })
    },
  },

  data() {
    return {
      defaultValues: {
        lastName: this.renewalData.lastName || '',
        firstName: this.renewalData.firstName || '',
        middleName: this.renewalData.middleName || '',
        dateBirth: this.renewalData.dateBirth || '',
        documentSeries: this.renewalData.passportSeries || '',
        documentNumber: this.renewalData.passportNumber || '',
        monitoringEndDate: '',
        agreementReceived: []
      },
      errors: {},
      isRequestCreating: false,
      isBackendError: false,
      backendErrorMessage: '',
      monitoringEndDate: null,
      monitoringDateError: null,
      calculatedTotal: this.productData.cost || 0,
      originalMonitoringEnd: this.renewalData.currentMonitoringEnd || null,
    };
  },

  methods: {
    handleSubmit(values) {
      if (this.isRequestCreating) {
        return;
      }

      const dateError = this.validateMonitoringDate(values.monitoringEndDate);
      if (dateError) {
        this.monitoringDateError = dateError;
        return;
      }

      this.isRequestCreating = true;
      this.isBackendError = false;

      const requestData = {
        monitoringEndDate: values.monitoringEndDate,
        monitoringId: this.renewalData.monitoringId
      };

      this.onRenewal(requestData).then((res) => {
        this.$router.push({ name: "requests" });
      }).catch(error => {
        this.backendErrorMessage = (error.data && error.data.message) || 'Произошла ошибка при создании запроса';
        this.isRequestCreating = false;
        this.isBackendError = true;
      });
    },

    validateMonitoringDate(date) {
      if (!date) {
        return 'Поле обязательно для заполнения';
      }

      const dateRegex = /^(0[1-9]|1[0-2])\/\d{4}$/;
      if (!dateRegex.test(date)) {
        return 'Неверный формат даты. Используйте ММ/ГГГГ';
      }

      const [inputMonth, inputYear] = date.split('/').map(Number);

      if (inputMonth < 1 || inputMonth > 12) {
        return 'Месяц должен быть от 01 до 12';
      }

      const now = new Date();
      const currentDateYear = now.getFullYear();
      const currentDateMonth = now.getMonth() + 1;

      let minMonth, minYear;

      if (this.originalMonitoringEnd) {
        const [origMonth, origYear] = this.originalMonitoringEnd.split('/').map(Number);

        if (origYear < currentDateYear ||
          (origYear === currentDateYear && origMonth < currentDateMonth)) {
          minMonth = currentDateMonth;
          minYear = currentDateYear;
        } else {
          minMonth = origMonth + 1;
          minYear = origYear;
          if (minMonth > 12) {
            minMonth = 1;
            minYear += 1;
          }
        }
      } else {
        minMonth = currentDateMonth;
        minYear = currentDateYear;
      }

      if (inputYear < minYear) {
        return `Дата окончания должна быть не ранее ${String(minMonth).padStart(2, '0')}/${minYear}`;
      }

      if (inputYear === minYear && inputMonth < minMonth) {
        return `Дата окончания должна быть не ранее ${String(minMonth).padStart(2, '0')}/${minYear}`;
      }

      const inputDate = new Date(inputYear, inputMonth - 1, 1);
      const currentMonthStart = new Date(currentDateYear, currentDateMonth - 1, 1);

      if (inputDate < currentMonthStart) {
        return 'Дата окончания не может быть в прошлом';
      }

      return null;
    },

    onMonitoringDateChange(value) {
      this.monitoringEndDate = value;
      this.monitoringDateError = this.validateMonitoringDate(value);
      this.updateTotal();
    },

    updateTotal() {
      const baseCost = this.productData.cost || 0;

      if (!this.monitoringEndDate) {
        this.calculatedTotal = baseCost;
        console.log('Стоимость без продления:', this.calculatedTotal);
        return;
      }

      const monthsCount = this.getMonthsCount(this.monitoringEndDate);
      this.calculatedTotal = baseCost * monthsCount;
    },

    getMonthsCount(newEndDate) {
      if (!newEndDate) return 1;

      try {
        const [newMonth, newYear] = newEndDate.split('/').map(Number);

        // Получаем текущую дату
        const now = new Date();
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        const currentFirstDay = new Date(currentYear, currentMonth - 1, 1);

        let startMonth, startYear;

        if (this.originalMonitoringEnd) {
          const [origMonth, origYear] = this.originalMonitoringEnd.split('/').map(Number);
          const origLastDay = new Date(origYear, origMonth, 0); // последний день месяца

          if (origLastDay < currentFirstDay) {
            // Мониторинг уже закончился
            // Если текущий месяц уже начался, начинаем со следующего месяца
            if (now > currentFirstDay) {
              startMonth = currentMonth + 1;
              startYear = currentYear;
              if (startMonth > 12) {
                startMonth = 1;
                startYear += 1;
              }
            } else {
              startMonth = currentMonth;
              startYear = currentYear;
            }
          } else {
            startMonth = origMonth + 1;
            startYear = origYear;
            if (startMonth > 12) {
              startMonth = 1;
              startYear += 1;
            }
          }
        } else {
          if (now > currentFirstDay) {
            startMonth = currentMonth + 1;
            startYear = currentYear;
            if (startMonth > 12) {
              startMonth = 1;
              startYear += 1;
            }
          } else {
            startMonth = currentMonth;
            startYear = currentYear;
          }
        }

        const months = (newYear - startYear) * 12 + (newMonth - startMonth) + 1;

        return Math.max(1, months);
      } catch (error) {
        console.log('Ошибка расчета месяцев:', error);
        return 1;
      }
    },

    getNextMonth(currentDate) {
      if (!currentDate) return '';

      const [month, year] = currentDate.split('/').map(Number);
      let nextMonth = month + 1;
      let nextYear = year;

      if (nextMonth > 12) {
        nextMonth = 1;
        nextYear = year + 1;
      }

      return `${String(nextMonth).padStart(2, '0')}/${nextYear}`;
    },
  },

  computed: {
    isFormValid() {
      console.log('=== Проверка isFormValid ===');

      const hasDateError = this.monitoringDateError != null && this.monitoringDateError !== '';
      const isDateValid = this.monitoringEndDate && !hasDateError;

      const formApi = this.$refs.form;
      const isAgreementChecked = formApi ?
        (formApi.getValue('agreementReceived') || []).length > 0 :
        false;

      console.log('isDateValid:', isDateValid);
      console.log('isAgreementChecked:', isAgreementChecked);

      const isValid = isDateValid && isAgreementChecked;
      console.log('Результат isValid:', isValid);

      return isValid;
    },

    placeholderDate() {
      const now = new Date();
      const currentDateYear = now.getFullYear();
      const currentDateMonth = now.getMonth() + 1;

      if (this.originalMonitoringEnd) {
        const [month, year] = this.originalMonitoringEnd.split('/').map(Number);

        if (year < currentDateYear || (year === currentDateYear && month < currentDateMonth)) {
          return `Минимум ${String(currentDateMonth).padStart(2, '0')}/${currentDateYear}`;
        } else {
          let nextMonth = month + 1;
          let nextYear = year;

          if (nextMonth > 12) {
            nextMonth = 1;
            nextYear = year + 1;
          }

          return `Минимум ${String(nextMonth).padStart(2, '0')}/${nextYear}`;
        }
      }

      return `Минимум ${String(currentDateMonth).padStart(2, '0')}/${currentDateYear}`;
    }
  },

  mounted() {
    console.log('Компонент продления загружен, productData:', this.productData);
    console.log('Базовая стоимость:', this.calculatedTotal);
    this.updateTotal();

    this.$nextTick(() => {
      console.log('Form ref available:', !!this.$refs.form);
    });
  },
};
</script>


// WEBPACK FOOTER //
// RenewalMonitoring.vue?865624a4